import { Trans } from '@lingui/react/macro';

import { PriceAmount } from '@/api';
import Badge from '@/design_system/Badge';
import Button from '@/design_system/Button';
import Tooltip from '@/design_system/Tooltip';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconRefusal from '@/icons/Refusal.svg';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import { formatCurrency } from '@/utils/number';
import useViewPort from '@/utils/useViewport';

export const CancellationFeeBadge = ({
  cancellationFeeAgreementPrice,
}: {
  cancellationFeeAgreementPrice: PriceAmount;
}) => {
  const { isMobile, isTablet } = useViewPort();
  const { view } = useRequestContext();

  const amount = formatCurrency(
    view.workshopPrice.showAmountBeforeTaxes
      ? cancellationFeeAgreementPrice.amountBeforeTaxes
      : cancellationFeeAgreementPrice.amount,
    cancellationFeeAgreementPrice.currency
  );

  return (
    <Tooltip
      content={
        <div>
          <Paragraph>
            <Trans id="components.workshop-list.cancellation-fees.amount-per-item">
              {amount}
              /item
            </Trans>
          </Paragraph>
        </div>
      }
      placement="top"
    >
      <Button variant="style-less">
        <Badge size="small" color="warning" borderRadius="soft" hasBorder>
          <IconRefusal />
          {!isMobile && !isTablet && (
            <Trans id="components.workshop-list.cancellation-fees">Cancellation fees</Trans>
          )}
        </Badge>
      </Button>
    </Tooltip>
  );
};
